import React, { useState } from 'react';
import { FormControlLabel, TextField } from '@mui/material';
import { removeWhitespaceSpecialCharacters } from 'utils/stringUtils';
import { theme } from 'theme';

type TextFilterProps = {
  filterName: string;
  placeholderText: string;
  defaultValue?: string;
  dispatchAction: (value: string) => void;
};

const styles = {
  // TODO - remove this and add to default theme ??!
  labelRoot: {
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  labelPlacementTop: {
    alignItems: 'flex-start',
  },
  // TODO - remove this and add to default theme ??!
  textInput: {
    marginTop: theme.spacing(0.5),
    width: '90%',
    maxWidth: 230,
    '& .MuiFilledInput-inputMarginDense': {
      paddingLeft: theme.spacing(1.5),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      width: '100%',
    },
  },
};

/**
 * A component that allows filtering the partner list via the text field input
 * Uses debouncing (only dispatches to Redux after the user stops typing)
 * @param filterName The name of the filter, displayed in the label
 * @param placeholderText The text to display if the field is empty
 * @param defaultValue The default value of the filter
 * @param dispatchAction The action to be executed
 */
export const TextFilter = ({ filterName, placeholderText, defaultValue, dispatchAction }: TextFilterProps) => {
  const [value, setValue] = useState(defaultValue ?? '');

  const handleChange = (onChangeValue: string) => {
    dispatchAction(onChangeValue);
    setValue(onChangeValue);
  };

  return (
    // TODO - check styling in browser
    <FormControlLabel
      data-testid={'text-filter-container-form-control-label'}
      control={
        <TextField
          id={`${removeWhitespaceSpecialCharacters(filterName)}-filter-input`}
          data-testid={`${removeWhitespaceSpecialCharacters(filterName)}-filter-input`}
          variant="filled"
          margin="dense"
          sx={styles.textInput}
          placeholder={placeholderText}
          value={value}
          type={'number'}
          inputProps={{
            'data-testid': `${removeWhitespaceSpecialCharacters(filterName)}-filter-input-html-element`,
          }}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
            handleChange(event.target.value)
          }
          InputProps={{ disableUnderline: true }}
          onInput={(e) => {
            // @ts-expect-error e.target.value is available on input elements
            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 8);
          }}
        />
      }
      label={filterName}
      labelPlacement="top"
    />
  );
};
